<template>
  <div class="channelRecord">
    <PageNav :openMenu="openMenu">
      <el-main>
        <div id="page-custoMersmanage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">名单撞单记录</span>
            </div>
          </div>
          <div class="custoMersmanage-container">
            <div class="content" style="padding-top: 0">
              <div class="content-nav--head text-1 Tab-nav-head">
                <div class="c-n--head_lf">
                  <ul class="filter-condition">
                    <li
                      v-for="(item, index) in filtersOption"
                      :key="index"
                      :class="{ 'link-active': item.id == currentId }"
                      @click="changeFilter(item)"
                    >
                      <span class="tag-label">
                        {{ item.label }}
                        <span class="tag-num" v-if="item.value">
                          {{ item.value }}
                        </span>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <collision-record v-if="currentId == 1"></collision-record>
              <apply-record v-if="currentId == 2"></apply-record>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
import applyRecord from "./channelChangeRecord/applyRecord.vue";
import collisionRecord from "./channelChangeRecord/collisionRecord.vue";
export default {
  name: "CustoMersmanage-custoMersmanage",
  data() {
    return {
      openMenu: ["3"],
      currentId: 1,
      filtersOption: [
        { label: "名单撞单记录", value: 0, id: 1 },
        { label: "渠道变更记录", value: 0, id: 2 },
      ],
    };
  },
  components: {
    PageNav,
    applyRecord,
    collisionRecord,
  },
  watch: {},
  created() {
    const type = this.$route.query.type || 1;
    this.currentId = type;
  },
  mounted() {},
  methods: {
    changeFilter(item) {
      this.currentId = item.id;
      // this.selectForm.overduetype = item.id;
      // this.currentPage = 1;
      // this.pageSize = 10;
      // this.getIntentionNumFn();
      // this.getgetClientData();
    },
  },
};
</script>
<style lang="less" scoped>
.content-nav--head {
  padding: 0px 20px 0px 0px;
  .filter-condition li {
    padding: 0px 20px;
    position: relative;
    .tag-label {
      position: relative;
    }
    .tag-num {
      position: absolute;
      top: -10px;
      left: 100%;
      background-color: red;
      color: #fff;
      height: 20px;
      padding: 0 8px;
      border-radius: 20px;
      font-size: 12px;
      text-align: center;
      line-height: 20px;
      white-space: nowrap;
    }
  }
}
</style>
